export const dataMock = [
  {
    pv: 5,
    weather: '01d',
    timestamp: Number('1636390663'),
  },
  {
    pv: 5,
    weather: '01d',
    timestamp: Number('1619733248'),
  },
  {
    pv: 5,
    weather: '01d',
    timestamp: Number('1641347431'),
  },
  {
    pv: 5,
    weather: '01d',
    timestamp: Number('1638373306'),
  },
  {
    pv: 5,
    weather: '01d',
    timestamp: Number('1630656437'),
  },
  {
    pv: 5,
    weather: '01d',
    timestamp: Number('1625975861'),
  },
  {
    pv: 5,
    weather: '01d',
    timestamp: Number('1647429802'),
  },
];
